module.exports = __webpack_public_path__ + "static/media/logo.5e03a2c7.jpg";